import axios from "axios";
import * as ApiSettings from "./apiSettings";
import { getDefaultHeaders } from "./apiSettings";
import qs from "qs";

const defaultServicePath = "/api/services/app/";

type Verbs = "get" | "delete" | "post" | "put" | any;
type Methods = "get" | "getAll" | "create" | "update" | "delete" | any;

export default class AbpAppService {
  serviceName: string | null = null;
  servicePath: string | null = null;

  constructor(serviceName: string, servicePath?: string) {
    this.serviceName = serviceName;
    this.servicePath = servicePath || defaultServicePath;
  }

  invoke(verb: Verbs, methodName: Methods, input?: any, bearerToken?: string) {
    const headers = {
      ...getDefaultHeaders(),
    };

    if (bearerToken) {
      headers.Authorization = `Bearer ${bearerToken}`;
    }

    let result = null;
    switch (verb) {
      case "get":
        result = axios.get(
          `${ApiSettings.apiBaseUrl}${this.servicePath}${this.serviceName}/${methodName}`,
          {
            headers: headers,
            params: input,
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          }
        );
        break;
      case "delete":
        result = axios.delete(
          `${ApiSettings.apiBaseUrl}${this.servicePath}${this.serviceName}/${methodName}`,
          {
            headers: headers,
            params: input,
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          }
        );
        break;
      default:
        result = (axios as any)[verb](
          `${ApiSettings.apiBaseUrl}${this.servicePath}${this.serviceName}/${methodName}`,
          input,
          {
            headers: headers,
          }
        );
        break;
    }
    return result;
  }

  getAll = (input: object, authToken?: string) => {
    let newInput = { ...input, MaxResultCount: 2147483647 };
    return this.invoke("get", "getAll", newInput, authToken);
  };

  get = (input: any, authToken?: string) => {
    return this.invoke("get", "get", input, authToken);
  };

  create = (input: any, authToken?: string) => {
    return this.invoke("post", "create", input, authToken);
  };

  update = (input: any, authToken?: string) => {
    return this.invoke("put", "update", input, authToken);
  };

  delete = (input: any, authToken?: string) => {
    return this.invoke("delete", "delete", input, authToken);
  };
}
